import { createSelector } from 'reselect'
import { RootState } from '../root/RootState'


export const onBoardingsSelector = (state: RootState) => state.onBoardings

export const onBoardingSelector = (name: string) => createSelector(onBoardingsSelector, onboardings => onboardings[name])

export const isOnBoardingStepActiveSelector = (name: string, step: number) => createSelector(onBoardingSelector(name), ob => step === ob?.currentStep)
